export interface LeafVisibility {
  searching: boolean
  focus: Set<string>
}

/**
 * Whether a node's services are drawn: when the node is pointed at or selected, or during a search.
 * (`Show Services` was a switch that drew them all; it is gone, app#455, Benoit 2026-10-02: "this
 * is useless".)
 *
 * ⚠⚠ A SEARCH DRAWS THEM ALL, AND THE GRAPH GOES BLANK WITHOUT THAT. `applySearchFilter` keeps
 * only what a match can be reached from, and a leaf that was never put in the map cannot match.
 * Hiding a kind of leaf by default turned a search for it into an empty canvas before app#309 —
 * five nodes in, zero out.
 *
 * ⚠ `focus` holds NODE ids, and it is hover AND selection, not one or the other. Hover is what
 * made a service expand before this existed, so a rule that took only selection would be a
 * regression.
 */
export function leafVisible(nodeId: string, { searching, focus }: LeafVisibility): boolean {
  return searching || focus.has(nodeId)
}
